import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-start gap-10">
          <div className="lg:w-1/3">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-tight mb-4">
              按分类浏览
              <br />
              发现你的喜好
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">
              从恋爱甜宠到热血格斗，从悬疑推理到治愈日常。七大漫画分类，总有一款适合你的口味。
            </p>
            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看全部漫画
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:w-2/3 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {displayCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-50 hover:bg-primary-50 border border-transparent hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                  <i className={`${cat.icon} text-accent-600 text-xl md:text-2xl`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}